import { Box, Button, Divider, Grid, Stack, Typography } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import TelegramIcon from "@mui/icons-material/Telegram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useThemeProvider } from "../../providers/ThemeProvider";
import { LinkValues } from "../../values/strings";
import { useLanguageProvider } from "../../providers/LanguageProvider";

export const SampleFooterComponent = () => {
  const theme = useThemeProvider();
  const { t, i18n } = useTranslation();
  const lang = useLanguageProvider();
  return (
    <Box paddingX={{ md: 7, xs: 2 }}>
      <Grid container paddingTop={3} paddingBottom={3} rowSpacing={3}>
        <Grid item lg={3} sm={6} xs={12}>
          <Stack>
            <Typography variant="title">{t("app_name")}</Typography>
            <Box paddingY="5px">
              <Link
                to={LinkValues.routes.initLocale(
                  LinkValues.routes.about.self(false),
                  lang.supportedLanguages
                )}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("aboutUs")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={LinkValues.routes.initLocale(
                  LinkValues.routes.terms.self(false),
                  lang.supportedLanguages
                )}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("terms2")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={LinkValues.routes.initLocale(
                  LinkValues.routes.privacy.self(false),
                  lang.supportedLanguages
                )}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("privacyPolicy")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("careers")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("faq")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("blog")}
              </Link>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={3} sm={6} xs={12}>
          <Stack>
            <Typography variant="title">{t("services")}</Typography>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("exchange")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("referral")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("rebixSavings")}
              </Link>
            </Box>
          </Stack>
        </Grid>
        <Grid item lg={3} sm={6} xs={12}>
          <Stack>
            <Typography variant="title">{t("contactInfo")}</Typography>
            <Box paddingY="5px" fontSize={13}>
              {t("tel")}: 02191031916
            </Box>
            <Box paddingY="5px" fontSize={13}>
              {t("whatsappNumber")}: 09360512200{" "}
            </Box>
          </Stack>
        </Grid>
        {/*
        <Grid item lg={3} sm={6} xs={12}>
          <Stack>
            <Typography variant="title">{t("buyCrypto")}</Typography>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("buyBitcoin")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
                LinkComponent={Link}
              >
                {t("buyEthereum")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("buyBnb")}
              </Link>
            </Box>
            <Box paddingY="5px">
              <Link
                to={"#"}
                underline="hover"
                className={theme.styles.classes.linkSecondary}
              >
                {t("buyDogecoin")}
              </Link>
            </Box>
          </Stack>
        </Grid> */}
        <Grid item lg={3} sm={6} xs={12}>
          <Grid container direction="column">
            <Grid item>
              <Typography variant="title">{t("rebixCommunity")}</Typography>
              <Box paddingY="5px">
                <Grid container>
                  <Grid item xs={2}>
                    <Link
                      to={"#"}
                      underline="hover"
                      className={theme.styles.classes.linkSecondary}
                    >
                      <TwitterIcon />
                    </Link>
                  </Grid>
                  <Grid item xs={2}>
                    <Link
                      to={"#"}
                      underline="hover"
                      className={theme.styles.classes.linkSecondary}
                    >
                      <TelegramIcon />
                    </Link>
                  </Grid>
                  <Grid item xs={2}>
                    <Link
                      to={"#"}
                      underline="hover"
                      className={theme.styles.classes.linkSecondary}
                    >
                      <InstagramIcon />
                    </Link>
                  </Grid>
                  <Grid item xs={2}>
                    <Link
                      to={"#"}
                      underline="hover"
                      className={theme.styles.classes.linkSecondary}
                    >
                      <FacebookIcon />
                    </Link>
                  </Grid>
                  <Grid item xs={4}>
                    <Link
                      to={"#"}
                      underline="hover"
                      className={theme.styles.classes.linkSecondary}
                    >
                      <YouTubeIcon />
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            {i18n.resolvedLanguage === "fa" && (
              <Grid item>
                <Box paddingY="5px" />
                <Typography variant="title">{t("licences")}</Typography>
                <Box paddingY="5px">
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=252166&Code="
                  >
                    <img
                      referrerPolicy="origin"
                      src="https://trustseal.enamad.ir/logo.aspx?id=252166&Code="
                      alt=""
                      style={{cursor: "pointer"}}
                    />
                  </a>
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Divider />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          padding: "20px 0",
        }}
      >
        <Typography variant="caption">
          REBIX © {new Date().getFullYear()}
        </Typography>
      </div>
    </Box>
  );
};
